// Mock data for I Got Soul streaming platform
export const mockMovies = [
  {
    id: 1,
    title: "Stranger Things",
    description: "When a young boy vanishes, a small town uncovers a mystery involving secret experiments, terrifying supernatural forces, and one strange little girl.",
    poster: "https://image.tmdb.org/t/p/w500/49WJfeN0moxb9IPfGn8AIqMGskD.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/56v2KjBlU4XaOv9rVYEQypROD7P.jpg",
    videoId: "b9EkMc79ZSU",
    genre: "Sci-Fi",
    year: 2016,
    rating: "TV-14",
    duration: "51m",
    isTrending: true,
    isNetflixOriginal: true
  },
  {
    id: 3,
    title: "Wednesday",
    description: "Smart, sarcastic and a little dead inside, Wednesday Addams investigates a murder spree while making new friends — and foes — at Nevermore Academy.",
    poster: "https://image.tmdb.org/t/p/w500/9PFonBhy4cQy7Jz20NpMygczOkv.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/iHSwvRVsRyxpX7FE7GbviaDvgGZ.jpg",
    videoId: "Di310WS8zLk",
    genre: "Comedy",
    year: 2022,
    rating: "TV-14",
    duration: "50m",
    isTrending: true,
    isNetflixOriginal: true
  },
  {
    id: 4,
    title: "Money Heist",
    description: "An unusual group of robbers attempt to carry out the most perfect robbery in Spanish history - stealing 2.4 billion euros from the Royal Mint of Spain.",
    poster: "https://image.tmdb.org/t/p/w500/reEMJA1uzscCbkpeRJeTT2bjqUp.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/xGExQasKcLexbTHqb1dhC6XYqcB.jpg",
    videoId: "htqXL94Rza4",
    genre: "Crime",
    year: 2017,
    rating: "TV-MA",
    duration: "67m",
    isNetflixOriginal: true
  },
  {
    id: 5,
    title: "Ozark",
    description: "A financial advisor drags his family from Chicago to the Missouri Ozarks, where he must launder money to appease a drug boss.",
    poster: "https://image.tmdb.org/t/p/w500/m73QxzCiZFXnKoR4HMj4pzKGKWG.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/aWPhMZ0P2DyfWB7k5NXhGHSZHGC.jpg",
    videoId: "5hAXVqrljbs",
    genre: "Crime",
    year: 2017,
    rating: "TV-MA",
    duration: "60m",
    isNetflixOriginal: true
  },
  {
    id: 6,
    title: "The Witcher",
    description: "Geralt of Rivia, a mutated monster-hunter for hire, journeys toward his destiny in a turbulent world where people often prove more wicked than beasts.",
    poster: "https://image.tmdb.org/t/p/w500/7vjaCdMw15FEbXyLQTVa04URsPm.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/1S1oh8NYttr5sekBFkqgjymPzxo.jpg",
    videoId: "ndl1W4ltcmg",
    genre: "Fantasy",
    year: 2019,
    rating: "TV-MA",
    duration: "60m",
    isNetflixOriginal: true
  },
  {
    id: 7,
    title: "Breaking Bad",
    description: "A high school chemistry teacher diagnosed with inoperable lung cancer turns to manufacturing and selling methamphetamine in order to secure his family's future.",
    poster: "https://image.tmdb.org/t/p/w500/3xnWaLQjelJDDF7LT1WBo6f4BRe.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/tsRy63Mu5cu8etL1X7ZLyf7UP1M.jpg",
    videoId: "HhesaQXLuRY",
    genre: "Drama",
    year: 2008,
    rating: "TV-MA",
    duration: "47m",
    isTrending: true
  },
  {
    id: 8,
    title: "Vikings",
    description: "Vikings transports us to the brutal and mysterious world of Ragnar Lothbrok, a Viking warrior and farmer who yearns to explore--and raid--the distant shores across the ocean.",
    poster: "https://image.tmdb.org/t/p/w500/bQLrHIRNEkE3PdIWQrZHynQZazu.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/A30ZqEoDbchvE7mCZcSp6TEwB1Q.jpg",
    videoId: "9GI9Qbn05Gs",
    genre: "Action",
    year: 2013,
    rating: "TV-MA",
    duration: "44m"
  },
  {
    id: 9,
    title: "Dark",
    description: "A family saga with a supernatural twist, set in a German town, where the disappearance of two young children exposes the relationships among four families.",
    poster: "https://image.tmdb.org/t/p/w500/apbrbWs8M9lyOpJYU5WXrpFbk1Z.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/5LDBEeROFUN5axP8VB8lCNJEznS.jpg",
    videoId: "rrwycJ08PSA",
    genre: "Mystery",
    year: 2017,
    rating: "TV-MA",
    duration: "60m",
    isNetflixOriginal: true
  },
  {
    id: 10,
    title: "Atlanta",
    description: "Two cousins work through the Atlanta music scene in order to better their lives and the lives of their families.",
    poster: "https://image.tmdb.org/t/p/w500/8HZyGMnPLdVKah3UsCw0yQyTGCk.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/9dWGGst7h3ePg5HfAFwYJ3j6RRE.jpg",
    videoId: "UZl-kQ3JFNI",
    genre: "Comedy",
    year: 2016,
    rating: "TV-MA",
    duration: "30m",
    isGetDiscovered: true
  },
  {
    id: 11,
    title: "Black Panther",
    description: "T'Challa, heir to the hidden but advanced kingdom of Wakanda, must step forward to lead his people into a new future and confront a challenger from his country's past.",
    poster: "https://image.tmdb.org/t/p/w500/uxzzxijgPIY7slzFvMotPv8wjKA.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/b6ZJZHUdMEFECvGiDpJjlfUWela.jpg",
    videoId: "xjDjIWPwcPU",
    genre: "Action",
    year: 2018,
    rating: "PG-13",
    duration: "134m",
    isGetDiscovered: true,
    isTrending: true
  },
  {
    id: 12,
    title: "Insecure",
    description: "Follows the friendship of two modern-day black women and their uncomfortable experiences and romantic tribulations.",
    poster: "https://image.tmdb.org/t/p/w500/qEf8LP3ge8KCyG4l1pb9w0MMzXZ.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/63c27GpvQKxrYdKzxHqfvyeirf6.jpg",
    videoId: "5x7GaVEGFnE",
    genre: "Romance",
    year: 2016,
    rating: "TV-MA",
    duration: "30m",
    isGetDiscovered: true
  },
  {
    id: 13,
    title: "Bad Boys for Life",
    description: "Marcus and Mike have to confront new threats, career changes, and midlife crises as they join the newly created elite team AMMO.",
    poster: "https://image.tmdb.org/t/p/w500/y95lQLnuNKdPAzw9F9Ab8kJ80c3.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/upUy2QhMZEmtypCelQs5mGAbYpw.jpg",
    videoId: "jKCj3XuPG8M",
    genre: "Action",
    year: 2020,
    rating: "R",
    duration: "124m",
    isGetDiscovered: true
  },
  {
    id: 14,
    title: "Coming 2 America",
    description: "The African monarch Akeem learns he has a long-lost son in the United States and must return to America to meet this unexpected heir.",
    poster: "https://image.tmdb.org/t/p/w500/nWBPLkqNApY5pgrJFMiI9joSI30.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/2Gspg9CatLxnr5FL4rgKE5lnF0s.jpg",
    videoId: "LbPw9AlVKHI",
    genre: "Comedy",
    year: 2021,
    rating: "PG-13",
    duration: "110m",
    isGetDiscovered: true
  },
  {
    id: 15,
    title: "Love & Basketball",
    description: "Monica and Quincy love and play basketball together through many life challenges from childhood to adulthood.",
    poster: "https://image.tmdb.org/t/p/w500/xhzMO7fl5MB1sJ5FCT6Wy88wGZW.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/3VihxbfMnR0xCmvaERNka3u5gYm.jpg",
    videoId: "Mzj_hN2J0Ic",
    genre: "Romance",
    year: 2000,
    rating: "PG-13",
    duration: "124m",
    isGetDiscovered: true
  },
  {
    id: 16,
    title: "Girls Trip",
    description: "Four lifelong friends have a wild weekend in New Orleans for their annual reunion.",
    poster: "https://image.tmdb.org/t/p/w500/ce14olSKU5j4vdYb5NYFFShEkzI.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/3jFbALyMky3PT2EKxajwVXEqY9j.jpg",
    videoId: "38NgLppeyMU",
    genre: "Comedy",
    year: 2017,
    rating: "R",
    duration: "122m",
    isGetDiscovered: true
  },
  {
    id: 17,
    title: "The Harder They Fall",
    description: "When an outlaw discovers his enemy is being released from prison, he reunites his gang to seek revenge.",
    poster: "https://image.tmdb.org/t/p/w500/su9WzL7lwUZPhjH6eZByAYFx2US.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/9pHxv7TX0jOKNgnGMDP6RJ2m1gl.jpg",
    videoId: "KEjj2-0bNE4",
    genre: "Action",
    year: 2021,
    rating: "R",
    duration: "139m",
    isNetflixOriginal: true,
    isGetDiscovered: true
  },
  {
    id: 18,
    title: "The Best Man Holiday",
    description: "When college friends reunite after 15 years over the Christmas holidays, they discover just how easy it is for long-forgotten rivalries and romances to be reignited.",
    poster: "https://image.tmdb.org/t/p/w500/rlRQoMIX8ry6xhnGdMT6gHphJ7c.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/uLI0EOlHJ2tDRh8pWUmor6g0iM4.jpg",
    videoId: "OXfhCU1xJlE",
    genre: "Romance",
    year: 2013,
    rating: "R",
    duration: "123m",
    isGetDiscovered: true
  },
  // Music Videos 2000-2020
  {
    id: 50,
    title: "Crazy in Love - Beyoncé",
    description: "Beyoncé's iconic music video featuring Jay-Z, showcasing fierce choreography and style.",
    poster: "https://i.ytimg.com/vi/ViwtNLUqkMY/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/ViwtNLUqkMY/maxresdefault.jpg",
    videoId: "ViwtNLUqkMY",
    genre: "Music Video",
    year: 2003,
    rating: "PG",
    duration: "4m",
    isMusicVideo: true
  },
  {
    id: 51,
    title: "Gold Digger - Kanye West",
    description: "Kanye West's hit single featuring Jamie Foxx with memorable beats and lyrics.",
    poster: "https://i.ytimg.com/vi/6vwNcNOTVzY/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/6vwNcNOTVzY/maxresdefault.jpg",
    videoId: "6vwNcNOTVzY",
    genre: "Music Video",
    year: 2005,
    rating: "PG",
    duration: "3m",
    isMusicVideo: true
  },
  {
    id: 52,
    title: "Single Ladies - Beyoncé",
    description: "The iconic dance routine that took the world by storm.",
    poster: "https://i.ytimg.com/vi/4m1EFMoRFvY/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/4m1EFMoRFvY/maxresdefault.jpg",
    videoId: "4m1EFMoRFvY",
    genre: "Music Video",
    year: 2008,
    rating: "PG",
    duration: "3m",
    isMusicVideo: true
  },
  {
    id: 53,
    title: "Yeah! - Usher",
    description: "The club anthem that dominated the early 2000s.",
    poster: "https://i.ytimg.com/vi/GxBSyx85Kp8/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/GxBSyx85Kp8/maxresdefault.jpg",
    videoId: "GxBSyx85Kp8",
    genre: "Music Video",
    year: 2004,
    rating: "PG",
    duration: "4m",
    isMusicVideo: true
  },
  {
    id: 54,
    title: "Formation - Beyoncé",
    description: "Powerful visual album showcasing Black culture and empowerment.",
    poster: "https://i.ytimg.com/vi/WDZJPJV__bQ/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/WDZJPJV__bQ/maxresdefault.jpg",
    videoId: "WDZJPJV__bQ",
    genre: "Music Video",
    year: 2016,
    rating: "PG",
    duration: "5m",
    isMusicVideo: true
  },
  {
    id: 55,
    title: "Hotline Bling - Drake",
    description: "Drake's viral dance moves in this minimalist yet iconic video.",
    poster: "https://i.ytimg.com/vi/uxpDa-c-4Mc/maxresdefault.jpg",
    backdrop: "https://i.ytimg.com/vi/uxpDa-c-4Mc/maxresdefault.jpg",
    videoId: "uxpDa-c-4Mc",
    genre: "Music Video",
    year: 2015,
    rating: "PG",
    duration: "5m",
    isMusicVideo: true
  },
  // Black Ninja Movies
  {
    id: 60,
    title: "The Last Dragon (Bruce Leroy)",
    description: "A young martial artist is on a quest to become a true martial arts master and must face the evil Sho'nuff, the Shogun of Harlem.",
    poster: "https://image.tmdb.org/t/p/w500/gQB8Y5RCMkv2zwzFHbUqXqvzYg0.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/rKsiNxKjhWEwndOgWPs273oy9S.jpg",
    videoId: "N0pb6773yxw",
    genre: "Black Ninja",
    year: 1985,
    rating: "PG-13",
    duration: "109m",
    isBlackNinja: true
  },
  {
    id: 61,
    title: "Enter the Dragon",
    description: "A martial artist agrees to spy on a reclusive crime lord using his invitation to a tournament there as cover.",
    poster: "https://image.tmdb.org/t/p/w500/hTWba50cScHl5MjzTwsh2Xbn7Bw.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/tJcYnoTmO3zz3A7r9NhawCqQeR3.jpg",
    videoId: "o5zHvViKsrY",
    genre: "Black Ninja",
    year: 1973,
    rating: "R",
    duration: "102m",
    isBlackNinja: true
  },
  {
    id: 62,
    title: "Black Belt Jones",
    description: "A federal agent whose karate skills are put to the test when he battles the mob.",
    poster: "https://image.tmdb.org/t/p/w500/gH2nBSV90DWUTCECyqfdSAuLuNT.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/x7HcZGdHsPpUhElBE5PkB8VbtGo.jpg",
    videoId: "Hb8DoBj1ApI",
    genre: "Black Ninja",
    year: 1974,
    rating: "R",
    duration: "87m",
    isBlackNinja: true
  },
  {
    id: 63,
    title: "Dolemite",
    description: "Rudy Ray Moore's legendary character Dolemite returns from prison to clean up his neighborhood.",
    poster: "https://image.tmdb.org/t/p/w500/bVTPxBmibVLy0w6Qf5jgOLFlXvG.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/9izNGXtY6y5qSRE9KhCyUJ9K1wP.jpg",
    videoId: "U7VwJg24b0I",
    genre: "Black Ninja",
    year: 1975,
    rating: "R",
    duration: "90m",
    isBlackNinja: true
  },
  {
    id: 64,
    title: "Black Samurai",
    description: "When the daughter of the U.S. Ambassador is kidnapped, Robert Sand, a karate expert, is called in to find her.",
    poster: "https://image.tmdb.org/t/p/w500/7PaVW5DbFlNS72aKyaLKNKbUIZn.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/yQnr5hsLLIZAp88rNHV0qfV36W6.jpg",
    videoId: "nRg_DDfNRA8",
    genre: "Black Ninja",
    year: 1977,
    rating: "R",
    duration: "88m",
    isBlackNinja: true
  },
  // Moved from Rolling Trailers to I Got Soul Originals
  {
    id: 70,
    title: "Black Panther",
    description: "T'Challa, heir to the hidden but advanced kingdom of Wakanda, must step forward to lead his people into a new future.",
    poster: "https://image.tmdb.org/t/p/w500/uxzzxijgPIY7slzFvMotPv8wjKA.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/b6ZJZHUdMEFECvGiDpJjlfUWela.jpg",
    videoId: "xjDjIWPwcPU",
    genre: "Action",
    year: 2018,
    rating: "PG-13",
    duration: "134m",
    isNetflixOriginal: true,
    isTrending: true
  },
  {
    id: 71,
    title: "Creed III",
    description: "Michael B. Jordan steps into the director's chair for this boxing drama featuring Adonis Creed facing his past.",
    poster: "https://image.tmdb.org/t/p/w500/cvsXj3I9Q2iyyIo95AecSd1tad7.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/2S1auGhz9B2DIVBhBc5ObiMeHQE.jpg",
    videoId: "AHmCH7iB_IM",
    genre: "Action", 
    year: 2023,
    rating: "PG-13",
    duration: "116m",
    isNetflixOriginal: true
  },
  {
    id: 72,
    title: "Afro Samurai",
    description: "Samuel L. Jackson voices a warrior on a quest for revenge in this stylized anime series.",
    poster: "https://image.tmdb.org/t/p/w500/uaXQKAK4sZl4dYq3uV3MF8ESh8N.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/cObF5PH8IBEM6rcmJrnhRQfgrxN.jpg",
    videoId: "cnZhgZK5Do4",
    genre: "Action",
    year: 2007,
    rating: "TV-MA",
    duration: "150m",
    isNetflixOriginal: true
  },
  {
    id: 73,
    title: "Nope",
    description: "Jordan Peele's mysterious sci-fi thriller starring Daniel Kaluuya about a UFO encounter.",
    poster: "https://image.tmdb.org/t/p/w500/AcKVlWaNVVVFQwro3nLXqPljcYA.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/57NVjbyQ8NEjOqwW6WwN5rVa60M.jpg",
    videoId: "In8fuzj3gck",
    genre: "Sci-Fi",
    year: 2022,
    rating: "R",
    duration: "130m",
    isNetflixOriginal: true
  },
  {
    id: 74,
    title: "Stranger Things",
    description: "When a young boy vanishes, a small town uncovers a mystery involving secret experiments and supernatural forces.",
    poster: "https://image.tmdb.org/t/p/w500/49WJfeN0moxb9IPfGn8AIqMGskD.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/56v2KjBlU4XaOv9rVYEQypROD7P.jpg",
    videoId: "b9EkMc79ZSU",
    genre: "Sci-Fi",
    year: 2016,
    rating: "TV-14",
    duration: "51m",
    isNetflixOriginal: true,
    isTrending: true
  },
  // Life Escape Category
  {
    id: 80,
    title: "Bee Movie",
    description: "Barry B. Benson, a bee just graduated from college, is disillusioned at his lone career choice: making honey.",
    poster: "https://image.tmdb.org/t/p/w500/1xlHV0AMoXQAOPAZXLQgq39tRCJ.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/7RRzKM1OK2FI4vrC4JsBQqLOzK.jpg",
    videoId: "VONRQMx78YI",
    genre: "Life Escape",
    year: 2007,
    rating: "PG",
    duration: "91m",
    isLifeEscape: true
  },
  {
    id: 81,
    title: "Batman v Superman: Dawn of Justice",
    description: "Batman is manipulated by Lex Luthor to fear Superman. Meanwhile, Superman's existence divides the world.",
    poster: "https://image.tmdb.org/t/p/w500/5UsK3grJvtQrtzEgqNlDljJW96w.jpg",
    backdrop: "https://image.tmdb.org/t/p/original/vsjBeMPZtyB7yNsYY56XYxifaQZ.jpg",
    videoId: "0WWzgGyAH6Y",
    genre: "Life Escape",
    year: 2016,
    rating: "PG-13",
    duration: "151m",
    isLifeEscape: true
  }
];

export const mockCategories = [
  {
    id: 1,
    title: "Get Discovered",
    movies: [] // Empty as requested
  },
  {
    id: 2,
    title: "Trending Now",
    movies: mockMovies.filter(movie => movie.isTrending)
  },
  {
    id: 3,
    title: "I Got Soul Originals",
    movies: mockMovies.filter(movie => movie.isNetflixOriginal)
  },
  {
    id: 4,
    title: "Black Ninja",
    movies: mockMovies.filter(movie => movie.isBlackNinja)
  },
  {
    id: 5,
    title: "Life Escape",
    movies: mockMovies.filter(movie => movie.isLifeEscape)
  },
  {
    id: 6,
    title: "Popular Black Cinema", 
    movies: mockMovies.filter(movie => movie.id >= 10 && movie.id <= 18) // Black movies from original Get Discovered
  },
  {
    id: 7,
    title: "Music Videos",
    movies: mockMovies.filter(movie => movie.isMusicVideo)
  },
  {
    id: 8,
    title: "Action & Adventure", 
    movies: mockMovies.filter(movie => movie.genre === "Action")
  },
  {
    id: 9,
    title: "Comedy Central",
    movies: mockMovies.filter(movie => movie.genre === "Comedy")
  },
  {
    id: 10,
    title: "Romance & Drama",
    movies: mockMovies.filter(movie => movie.genre === "Romance" || movie.genre === "Drama")
  },
  {
    id: 11,
    title: "Crime Thrillers",
    movies: mockMovies.filter(movie => movie.genre === "Crime")
  }
];

export const mockUser = {
  name: "John Doe",
  email: "john@example.com",
  avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=John",
  profiles: [
    { id: 1, name: "John", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=John" },
    { id: 2, name: "Sarah", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah" },
    { id: 3, name: "Kids", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Kids" }
  ]
};